// API bindings: calls (Auto generated)

"use strict";

import { RequestErrorHandler, RequestParams, CommonAuthenticatedErrorHandler, CommonErrorHandler } from "@asanrom/request-browser";
import { getApiUrl, generateURIQuery } from "./utils";
import { CallInfo, CallConfiguration, MeetLinkConfiguration, UserTargetPrivateSupport, CallVideoList, RecordingStartResponse, RecordCallRequest, CallVideo, StreamingLiveResponse, CallStatsTopItem, StreamingStatsItem, RecordingStatusResponse, BreakoutGroupsResponse, BreakoutGroupsRequest, BreakoutGroupsListResponse, BreakoutGroupActionResponse, BreakoutGroupEnterRequest, BreakoutGroupMoveRequest, BreakoutGroupReturnRequest, PrivateCallList, PrivateCallInfo, StartCallRecordResponse } from "./definitions";

export class ApiCalls {
    /**
     * Method: GET
     * Path: /room/{roomId}/call
     * Get call information
     * @param roomId Room ID
     * @param headerParams Header parameters
     * @returns The request parameters
     */
    public static GetRoomRoomidCall(roomId: string, headerParams: GetRoomRoomidCallHeaderParameters): RequestParams<CallInfo, GetRoomRoomidCallErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call`),
            headers: headerParams as any,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/call/config
     * Get call configuration
     * @param roomId Room ID
     * @returns The request parameters
     */
    public static GetRoomRoomidCallConfig(roomId: string): RequestParams<CallConfiguration, GetRoomRoomidCallConfigErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/config`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/config
     * Set call configuration
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallConfig(roomId: string, body: CallConfiguration): RequestParams<void, PostRoomRoomidCallConfigErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/config`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/meet
     * Set the room Google Meet link
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallMeet(roomId: string, body: MeetLinkConfiguration): RequestParams<MeetLinkConfiguration, PostRoomRoomidCallMeetErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/meet`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "INVALID_MEET_URL", handler.badRequestInvalidMeetUrl)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/mute
     * Mutes user sound (MOD)
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallMute(roomId: string, body: UserTargetPrivateSupport): RequestParams<void, PostRoomRoomidCallMuteErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/mute`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/unmute
     * Unmute user sound (MOD)
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallUnmute(roomId: string, body: UserTargetPrivateSupport): RequestParams<void, PostRoomRoomidCallUnmuteErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/unmute`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/turn
     * Gives turn
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallTurn(roomId: string, body: UserTargetPrivateSupport): RequestParams<void, PostRoomRoomidCallTurnErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/turn`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/kick
     * Kicks user from call (MOD)
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallKick(roomId: string, body: UserTargetPrivateSupport): RequestParams<void, PostRoomRoomidCallKickErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/kick`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/call/videos
     * Get list of call videos (recordings of calls)
     * It will return a max amount of items with the information to get the next page
     * @param roomId Room ID
     * @param queryParams Query parameters
     * @param headerParams Header parameters
     * @returns The request parameters
     */
    public static GetRoomRoomidCallVideos(roomId: string, queryParams: GetRoomRoomidCallVideosQueryParameters, headerParams: GetRoomRoomidCallVideosHeaderParameters): RequestParams<CallVideoList, GetRoomRoomidCallVideosErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/videos` + generateURIQuery(queryParams)),
            headers: headerParams as any,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/videos
     * Start a new call recording
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallVideos(roomId: string, body: RecordCallRequest): RequestParams<RecordingStartResponse, PostRoomRoomidCallVideosErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/videos`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/call/videos/{videoId}
     * Get call video
     * @param roomId Room ID
     * @param videoId Video ID
     * @param headerParams Header parameters
     * @returns The request parameters
     */
    public static GetRoomRoomidCallVideosVideoid(roomId: string, videoId: string, headerParams: GetRoomRoomidCallVideosVideoidHeaderParameters): RequestParams<CallVideo, GetRoomRoomidCallVideosVideoidErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/videos/${encodeURIComponent(videoId)}`),
            headers: headerParams as any,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/videos/{videoId}
     * Changes video title and description
     * @param roomId Room ID
     * @param videoId Video ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallVideosVideoid(roomId: string, videoId: string, body: RecordCallRequest): RequestParams<void, PostRoomRoomidCallVideosVideoidErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/videos/${encodeURIComponent(videoId)}`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: DELETE
     * Path: /room/{roomId}/call/videos/{videoId}
     * Deletes call video (ADMIN)
     * @param roomId Room ID
     * @param videoId Video ID
     * @returns The request parameters
     */
    public static DeleteRoomRoomidCallVideosVideoid(roomId: string, videoId: string): RequestParams<void, DeleteRoomRoomidCallVideosVideoidErrorHandler> {
        return {
            method: "DELETE",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/videos/${encodeURIComponent(videoId)}`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/videos/{videoId}/request_encode
     * Request video to be encoded to MP4 (for site admins)
     * @param roomId Room ID
     * @param videoId Video ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallVideosVideoidRequestencode(roomId: string, videoId: string, body: RecordCallRequest): RequestParams<void, PostRoomRoomidCallVideosVideoidRequestencodeErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/videos/${encodeURIComponent(videoId)}/request_encode`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/call/videos/{videoId}/{resolution}
     * Get call video playlist
     * @param roomId Room ID
     * @param videoId Video ID
     * @param resolution Resolution name
     * @param headerParams Header parameters
     * @returns The request parameters
     */
    public static GetRoomRoomidCallVideosVideoidResolution(roomId: string, videoId: string, resolution: string, headerParams: GetRoomRoomidCallVideosVideoidResolutionHeaderParameters): RequestParams<StreamingLiveResponse, GetRoomRoomidCallVideosVideoidResolutionErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/videos/${encodeURIComponent(videoId)}/${encodeURIComponent(resolution)}`),
            headers: headerParams as any,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/call/stats/top
     * Stats / Get top users activity in a 24 hour period
     * @param roomId Room ID
     * @param queryParams Query parameters
     * @returns The request parameters
     */
    public static GetRoomRoomidCallStatsTop(roomId: string, queryParams: GetRoomRoomidCallStatsTopQueryParameters): RequestParams<CallStatsTopItem[], GetRoomRoomidCallStatsTopErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/stats/top` + generateURIQuery(queryParams)),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/call/stats/user/{userId}
     * Stats / Get user activity stats (time in call)
     * @param roomId Room ID
     * @param userId User ID
     * @param queryParams Query parameters
     * @returns The request parameters
     */
    public static GetRoomRoomidCallStatsUserUserid(roomId: string, userId: string, queryParams: GetRoomRoomidCallStatsUserUseridQueryParameters): RequestParams<StreamingStatsItem[], GetRoomRoomidCallStatsUserUseridErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/stats/user/${encodeURIComponent(userId)}` + generateURIQuery(queryParams)),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/call/recording/status
     * Get room recording status
     * @param roomId Room ID
     * @param headerParams Header parameters
     * @returns The request parameters
     */
    public static GetRoomRoomidCallRecordingStatus(roomId: string, headerParams: GetRoomRoomidCallRecordingStatusHeaderParameters): RequestParams<RecordingStatusResponse, GetRoomRoomidCallRecordingStatusErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/recording/status`),
            headers: headerParams as any,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/breakout
     * Create breakout groups from the users currently connected to the main call.
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallBreakout(roomId: string, body: BreakoutGroupsRequest): RequestParams<BreakoutGroupsResponse, PostRoomRoomidCallBreakoutErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/breakout`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(409, "BREAKOUT_PLAN_LIMIT", handler.status409BreakoutPlanLimit)
                    .add(409, "ADMIN_NOT_IN_MAIN_CALL", handler.status409AdminNotInMainCall)
                    .add(409, "*", handler.status409)
                    .add(404, "ROOM_NOT_FOUND", handler.notFoundRoomNotFound)
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "BREAKOUT_CALL_LIMIT", handler.badRequestBreakoutCallLimit)
                    .add(400, "NOT_ENOUGH_BREAKOUT_PARTICIPANTS", handler.badRequestNotEnoughBreakoutParticipants)
                    .add(400, "INVALID_BREAKOUT_GROUPS", handler.badRequestInvalidBreakoutGroups)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/call/breakout
     * Get the current breakout groups and their connected participants.
     * @param roomId Room ID
     * @returns The request parameters
     */
    public static GetRoomRoomidCallBreakout(roomId: string): RequestParams<BreakoutGroupsListResponse, GetRoomRoomidCallBreakoutErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/breakout`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "ROOM_NOT_FOUND", handler.notFoundRoomNotFound)
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/breakout/enter
     * Force the authenticated administrator into one of the room's breakout groups.
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallBreakoutEnter(roomId: string, body: BreakoutGroupEnterRequest): RequestParams<BreakoutGroupActionResponse, PostRoomRoomidCallBreakoutEnterErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/breakout/enter`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "BREAKOUT_GROUP_NOT_FOUND", handler.notFoundBreakoutGroupNotFound)
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "INVALID_BREAKOUT_GROUP_CODE", handler.badRequestInvalidBreakoutGroupCode)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/breakout/leave
     * Force the authenticated administrator back to the main call.
     * @param roomId Room ID
     * @returns The request parameters
     */
    public static PostRoomRoomidCallBreakoutLeave(roomId: string): RequestParams<BreakoutGroupActionResponse, PostRoomRoomidCallBreakoutLeaveErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/breakout/leave`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "ROOM_NOT_FOUND", handler.notFoundRoomNotFound)
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/breakout/move
     * Move a connected participant to a breakout group.
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallBreakoutMove(roomId: string, body: BreakoutGroupMoveRequest): RequestParams<BreakoutGroupActionResponse, PostRoomRoomidCallBreakoutMoveErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/breakout/move`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(409, "BREAKOUT_USER_NOT_IN_CALL", handler.status409BreakoutUserNotInCall)
                    .add(409, "*", handler.status409)
                    .add(404, "BREAKOUT_GROUP_NOT_FOUND", handler.notFoundBreakoutGroupNotFound)
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "BREAKOUT_CALL_LIMIT", handler.badRequestBreakoutCallLimit)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/breakout/return
     * Return users in one private call, or every private call, in this room to the main call.
     * @param roomId Room ID
     * @param body Body parameters
     * @returns The request parameters
     */
    public static PostRoomRoomidCallBreakoutReturn(roomId: string, body: BreakoutGroupReturnRequest): RequestParams<BreakoutGroupsResponse, PostRoomRoomidCallBreakoutReturnErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/breakout/return`),
            json: body,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "BREAKOUT_GROUP_NOT_FOUND", handler.notFoundBreakoutGroupNotFound)
                    .add(404, "ROOM_NOT_FOUND", handler.notFoundRoomNotFound)
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "INVALID_BREAKOUT_GROUP_CODE", handler.badRequestInvalidBreakoutGroupCode)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/call/private
     * Get list of the private calls in the room (ADMIN)
     * It will return a max amount of items with the information to get the next page
     * @param roomId Room ID
     * @param queryParams Query parameters
     * @returns The request parameters
     */
    public static GetRoomRoomidCallPrivate(roomId: string, queryParams: GetRoomRoomidCallPrivateQueryParameters): RequestParams<PrivateCallList, GetRoomRoomidCallPrivateErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/private` + generateURIQuery(queryParams)),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: GET
     * Path: /room/{roomId}/call/private/{callId}
     * Get private call information
     * @param roomId Room ID
     * @param callId Call ID
     * @returns The request parameters
     */
    public static PrivateCallInfo(roomId: string, callId: string): RequestParams<PrivateCallInfo, PrivateCallInfoErrorHandler> {
        return {
            method: "GET",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/private/${encodeURIComponent(callId)}`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: DELETE
     * Path: /room/{roomId}/call/private/{callId}
     * Deletes private call (ADMIN)
     * @param roomId Room ID
     * @param callId Call ID
     * @returns The request parameters
     */
    public static DeleteRoomRoomidCallPrivateCallid(roomId: string, callId: string): RequestParams<void, DeleteRoomRoomidCallPrivateCallidErrorHandler> {
        return {
            method: "DELETE",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/private/${encodeURIComponent(callId)}`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/start-record
     * Starts call record
     * @param roomId Room ID
     * @returns The request parameters
     */
    public static StartCallRecord(roomId: string): RequestParams<StartCallRecordResponse, StartCallRecordErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/start-record`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "CALL_NOT_FOUND", handler.notFoundCallNotFound)
                    .add(404, "ROOM_NOT_FOUND", handler.notFoundRoomNotFound)
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "CALL_ALREADY_RECORDING", handler.badRequestCallAlreadyRecording)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/stop-record/{crid}
     * Stops call record
     * @param roomId Room ID
     * @param crid Call record ID
     * @returns The request parameters
     */
    public static StopCallRecord(roomId: string, crid: string): RequestParams<StartCallRecordResponse, StopCallRecordErrorHandler> {
        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/stop-record/${encodeURIComponent(crid)}`),
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "CALL_NOT_FOUND", handler.notFoundCallNotFound)
                    .add(404, "ROOM_NOT_FOUND", handler.notFoundRoomNotFound)
                    .add(404, "*", handler.notFound)
                    .add(403, "NOT_RECORD_ADMIN", handler.forbiddenNotRecordAdmin)
                    .add(403, "*", handler.forbidden)
                    .add(400, "CALL_NOT_RECORDING", handler.badRequestCallNotRecording)
                    .add(400, "*", handler.badRequest)
                    .add(401, "*", handler.unauthorized)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }

    /**
     * Method: POST
     * Path: /room/{roomId}/call/audio-chunk/{crid}
     * Upload audio chunk
     * @param roomId Room ID
     * @param crid Call record ID
     * @param formParams FromData parameters
     * @returns The request parameters
     */
    public static UploadAudioChunk(roomId: string, crid: string, formParams: UploadAudioChunkFormParameters): RequestParams<void, UploadAudioChunkErrorHandler> {
        const formData = new FormData();

        formParams.file !== undefined && formData.append("file", formParams.file);
        formParams.joinRecordTimestamp !== undefined && formData.append("joinRecordTimestamp", formParams.joinRecordTimestamp);

        return {
            method: "POST",
            url: getApiUrl(`/room/${encodeURIComponent(roomId)}/call/audio-chunk/${encodeURIComponent(crid)}`),
            form: formData,
            handleError: (err, handler) => {
                new RequestErrorHandler()
                    .add(404, "CALL_NOT_FOUND", handler.notFoundCallNotFound)
                    .add(404, "RECORD_NOT_FOUND", handler.notFoundRecordNotFound)
                    .add(404, "ROOM_NOT_FOUND", handler.notFoundRoomNotFound)
                    .add(404, "*", handler.notFound)
                    .add(403, "*", handler.forbidden)
                    .add(400, "CALL_NOT_RECORDING", handler.badRequestCallNotRecording)
                    .add(400, "INVALID_FILE", handler.badRequestInvalidFile)
                    .add(400, "INVALID_JOIN_RECORD_TIMESTAMP", handler.badRequestInvalidJoinRecordTimestamp)
                    .add(400, "*", handler.badRequest)
                    .add(500, "*", "serverError" in handler ? handler.serverError : handler.temporalError)
                    .add("*", "*", "networkError" in handler ? handler.networkError : handler.temporalError)
                    .handle(err);
            },
        };
    }
}

/**
 * Error handler for GetRoomRoomidCall
 */
export type GetRoomRoomidCallErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Header parameters for GetRoomRoomidCall
 */
export interface GetRoomRoomidCallHeaderParameters {
    /**
     * Version ID (when joining with code)
     */
    "x-room-version-id"?: string;

    /**
     * Version Code (when joining with code)
     */
    "x-room-version-code"?: string;
}

/**
 * Error handler for GetRoomRoomidCallConfig
 */
export type GetRoomRoomidCallConfigErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidCallConfig
 */
export type PostRoomRoomidCallConfigErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidCallMeet
 */
export type PostRoomRoomidCallMeetErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * Handler for status = 400 and code = INVALID_MEET_URL
     */
    badRequestInvalidMeetUrl: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidCallMute
 */
export type PostRoomRoomidCallMuteErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidCallUnmute
 */
export type PostRoomRoomidCallUnmuteErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidCallTurn
 */
export type PostRoomRoomidCallTurnErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidCallKick
 */
export type PostRoomRoomidCallKickErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for GetRoomRoomidCallVideos
 */
export type GetRoomRoomidCallVideosErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Query parameters for GetRoomRoomidCallVideos
 */
export interface GetRoomRoomidCallVideosQueryParameters {
    /**
     * ID of the oldest streaming video the client has (for next pages)
     */
    last?: string;
}

/**
 * Header parameters for GetRoomRoomidCallVideos
 */
export interface GetRoomRoomidCallVideosHeaderParameters {
    /**
     * Version ID (when joining with code)
     */
    "x-room-version-id"?: string;

    /**
     * Version Code (when joining with code)
     */
    "x-room-version-code"?: string;
}

/**
 * Error handler for PostRoomRoomidCallVideos
 */
export type PostRoomRoomidCallVideosErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for GetRoomRoomidCallVideosVideoid
 */
export type GetRoomRoomidCallVideosVideoidErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Header parameters for GetRoomRoomidCallVideosVideoid
 */
export interface GetRoomRoomidCallVideosVideoidHeaderParameters {
    /**
     * Version ID (when joining with code)
     */
    "x-room-version-id"?: string;

    /**
     * Version Code (when joining with code)
     */
    "x-room-version-code"?: string;
}

/**
 * Error handler for PostRoomRoomidCallVideosVideoid
 */
export type PostRoomRoomidCallVideosVideoidErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for DeleteRoomRoomidCallVideosVideoid
 */
export type DeleteRoomRoomidCallVideosVideoidErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for PostRoomRoomidCallVideosVideoidRequestencode
 */
export type PostRoomRoomidCallVideosVideoidRequestencodeErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for GetRoomRoomidCallVideosVideoidResolution
 */
export type GetRoomRoomidCallVideosVideoidResolutionErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Header parameters for GetRoomRoomidCallVideosVideoidResolution
 */
export interface GetRoomRoomidCallVideosVideoidResolutionHeaderParameters {
    /**
     * Version ID (when joining with code)
     */
    "x-room-version-id"?: string;

    /**
     * Version Code (when joining with code)
     */
    "x-room-version-code"?: string;
}

/**
 * Error handler for GetRoomRoomidCallStatsTop
 */
export type GetRoomRoomidCallStatsTopErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Query parameters for GetRoomRoomidCallStatsTop
 */
export interface GetRoomRoomidCallStatsTopQueryParameters {
    /**
     * Chosen timestamp, set 0 by default to take stats from now
     */
    from?: number;
}

/**
 * Error handler for GetRoomRoomidCallStatsUserUserid
 */
export type GetRoomRoomidCallStatsUserUseridErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Query parameters for GetRoomRoomidCallStatsUserUserid
 */
export interface GetRoomRoomidCallStatsUserUseridQueryParameters {
    /**
     * Chosen timestamp, set 0 by default to take stats from now
     */
    from?: number;

    /**
     * Interval: "1h" | "6h" | "12h" | "1d" | "3d" | "1w" | "1M" | "3M" | "6M" | "1y" | "all"
     */
    interval?: string;
}

/**
 * Error handler for GetRoomRoomidCallRecordingStatus
 */
export type GetRoomRoomidCallRecordingStatusErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Header parameters for GetRoomRoomidCallRecordingStatus
 */
export interface GetRoomRoomidCallRecordingStatusHeaderParameters {
    /**
     * Version ID (when joining with code)
     */
    "x-room-version-id"?: string;

    /**
     * Version Code (when joining with code)
     */
    "x-room-version-code"?: string;
}

/**
 * Error handler for PostRoomRoomidCallBreakout
 */
export type PostRoomRoomidCallBreakoutErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * Handler for status = 400 and code = INVALID_BREAKOUT_GROUPS
     */
    badRequestInvalidBreakoutGroups: () => void;

    /**
     * Handler for status = 400 and code = NOT_ENOUGH_BREAKOUT_PARTICIPANTS
     */
    badRequestNotEnoughBreakoutParticipants: () => void;

    /**
     * Handler for status = 400 and code = BREAKOUT_CALL_LIMIT
     */
    badRequestBreakoutCallLimit: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = ROOM_NOT_FOUND
     */
    notFoundRoomNotFound: () => void;

    /**
     * General handler for status = 409
     */
    status409: () => void;

    /**
     * Handler for status = 409 and code = ADMIN_NOT_IN_MAIN_CALL
     */
    status409AdminNotInMainCall: () => void;

    /**
     * Handler for status = 409 and code = BREAKOUT_PLAN_LIMIT
     */
    status409BreakoutPlanLimit: () => void;
};

/**
 * Error handler for GetRoomRoomidCallBreakout
 */
export type GetRoomRoomidCallBreakoutErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = ROOM_NOT_FOUND
     */
    notFoundRoomNotFound: () => void;
};

/**
 * Error handler for PostRoomRoomidCallBreakoutEnter
 */
export type PostRoomRoomidCallBreakoutEnterErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * Handler for status = 400 and code = INVALID_BREAKOUT_GROUP_CODE
     */
    badRequestInvalidBreakoutGroupCode: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = BREAKOUT_GROUP_NOT_FOUND
     */
    notFoundBreakoutGroupNotFound: () => void;
};

/**
 * Error handler for PostRoomRoomidCallBreakoutLeave
 */
export type PostRoomRoomidCallBreakoutLeaveErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = ROOM_NOT_FOUND
     */
    notFoundRoomNotFound: () => void;
};

/**
 * Error handler for PostRoomRoomidCallBreakoutMove
 */
export type PostRoomRoomidCallBreakoutMoveErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * Handler for status = 400 and code = BREAKOUT_CALL_LIMIT
     */
    badRequestBreakoutCallLimit: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = BREAKOUT_GROUP_NOT_FOUND
     */
    notFoundBreakoutGroupNotFound: () => void;

    /**
     * General handler for status = 409
     */
    status409: () => void;

    /**
     * Handler for status = 409 and code = BREAKOUT_USER_NOT_IN_CALL
     */
    status409BreakoutUserNotInCall: () => void;
};

/**
 * Error handler for PostRoomRoomidCallBreakoutReturn
 */
export type PostRoomRoomidCallBreakoutReturnErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * Handler for status = 400 and code = INVALID_BREAKOUT_GROUP_CODE
     */
    badRequestInvalidBreakoutGroupCode: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = ROOM_NOT_FOUND
     */
    notFoundRoomNotFound: () => void;

    /**
     * Handler for status = 404 and code = BREAKOUT_GROUP_NOT_FOUND
     */
    notFoundBreakoutGroupNotFound: () => void;
};

/**
 * Error handler for GetRoomRoomidCallPrivate
 */
export type GetRoomRoomidCallPrivateErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Query parameters for GetRoomRoomidCallPrivate
 */
export interface GetRoomRoomidCallPrivateQueryParameters {
    /**
     * ID of the oldest call the client has (for next pages)
     */
    last?: string;
}

/**
 * Error handler for PrivateCallInfo
 */
export type PrivateCallInfoErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for DeleteRoomRoomidCallPrivateCallid
 */
export type DeleteRoomRoomidCallPrivateCallidErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;
};

/**
 * Error handler for StartCallRecord
 */
export type StartCallRecordErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * Handler for status = 400 and code = CALL_ALREADY_RECORDING
     */
    badRequestCallAlreadyRecording: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = ROOM_NOT_FOUND
     */
    notFoundRoomNotFound: () => void;

    /**
     * Handler for status = 404 and code = CALL_NOT_FOUND
     */
    notFoundCallNotFound: () => void;
};

/**
 * Error handler for StopCallRecord
 */
export type StopCallRecordErrorHandler = CommonAuthenticatedErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * Handler for status = 400 and code = CALL_NOT_RECORDING
     */
    badRequestCallNotRecording: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * Handler for status = 403 and code = NOT_RECORD_ADMIN
     */
    forbiddenNotRecordAdmin: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = ROOM_NOT_FOUND
     */
    notFoundRoomNotFound: () => void;

    /**
     * Handler for status = 404 and code = CALL_NOT_FOUND
     */
    notFoundCallNotFound: () => void;
};

/**
 * Error handler for UploadAudioChunk
 */
export type UploadAudioChunkErrorHandler = CommonErrorHandler & {
    /**
     * General handler for status = 400
     */
    badRequest: () => void;

    /**
     * Handler for status = 400 and code = INVALID_JOIN_RECORD_TIMESTAMP
     */
    badRequestInvalidJoinRecordTimestamp: () => void;

    /**
     * Handler for status = 400 and code = INVALID_FILE
     */
    badRequestInvalidFile: () => void;

    /**
     * Handler for status = 400 and code = CALL_NOT_RECORDING
     */
    badRequestCallNotRecording: () => void;

    /**
     * General handler for status = 403
     */
    forbidden: () => void;

    /**
     * General handler for status = 404
     */
    notFound: () => void;

    /**
     * Handler for status = 404 and code = ROOM_NOT_FOUND
     */
    notFoundRoomNotFound: () => void;

    /**
     * Handler for status = 404 and code = RECORD_NOT_FOUND
     */
    notFoundRecordNotFound: () => void;

    /**
     * Handler for status = 404 and code = CALL_NOT_FOUND
     */
    notFoundCallNotFound: () => void;
};

/**
 * Form parameters for UploadAudioChunk
 */
export interface UploadAudioChunkFormParameters {
    /**
     * File to upload
     */
    file?: Blob;

    /**
     * Join Record Timestamp
     */
    joinRecordTimestamp?: string;
}

